// This file maps state to stores, and also exposes a fetchData function to fetch all the
// data needed to render the smart component
import BotStore from '@src/store';
import TemplateStore from 'stores/TemplateStore';

export const listenToStores = [BotStore, TemplateStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    allTemplates: TemplateStore.getAllTemplates(),
    canViewEditSmartSkill: BotStore.canViewEditSmartSkill(),
  };
}

export { getAllTemplatesForEditor } from 'actions/TemplateActions';
export { openComponentModal } from 'actions/BotActions';
